import { trackTranslationReview_LinkCopied } from '@src/analytics/EventTracker';
import { handleCopyToClipboard } from '@src/utility/general';

import type { ToastAction, ToastRequest } from '@src/stores/toast';

/**
 * PLAT-11877 — "Copy Review Link" on the translation "ready" toast.
 *
 * The workspace's own Copy Review Link (PLAT-11037) copies `location.href`,
 * because while the review is open the URL IS the link. The toast fires with
 * the review still closed, so each surface builds the params the review would
 * write — the same ones its hydration reads back — and this turns them into
 * the link and the toast action. Copying confirms with its own toast rather
 * than swapping the "ready" one, which keeps "Review Translation" up.
 */
export const REVIEW_LINK_COPIED_MESSAGE = 'Review link copied.';

export function reviewLinkFromParams(params: URLSearchParams): string {
  const search = params.toString();
  return `${window.location.origin}${window.location.pathname}${
    search ? `?${search}` : ''
  }`;
}

export function copyReviewLinkToastAction({
  href,
  showToast,
  analytics,
}: {
  href: string;
  showToast: (toast: ToastRequest) => void;
  analytics: Parameters<typeof trackTranslationReview_LinkCopied>[0];
}): ToastAction {
  return {
    label: 'Copy Review Link',
    onClick: async () => {
      if (!(await handleCopyToClipboard(href))) {
        showToast({ state: 'error', message: 'Could not copy link' });
        return;
      }
      trackTranslationReview_LinkCopied(analytics);
      showToast({ state: 'success', message: REVIEW_LINK_COPIED_MESSAGE });
    },
  };
}
